import { motion } from 'motion/react';
import styles from './QuizMetadataForm.module.scss';

interface QuizMetadataFormProps {
  name: string;
  originalPrompt: string;
  isDailyKnowledge: boolean;
  onNameChange: (name: string) => void;
  onPromptChange: (prompt: string) => void;
  onDailyKnowledgeChange: (isDailyKnowledge: boolean) => void;
}

export function QuizMetadataForm({
  name,
  originalPrompt,
  isDailyKnowledge,
  onNameChange,
  onPromptChange,
  onDailyKnowledgeChange,
}: QuizMetadataFormProps) {
  return (
    <motion.div
      className={styles.metadataForm}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.metadataForm__field}>
        <label htmlFor="quiz-name" className={styles.metadataForm__label}>
          Quiz Name <span className={styles.metadataForm__required}>*</span>
        </label>
        <input
          id="quiz-name"
          type="text"
          className={styles.metadataForm__input}
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Enter a descriptive name for your quiz"
          maxLength={100}
          required
        />
      </div>

      <div className={styles.metadataForm__field}>
        <label htmlFor="quiz-prompt" className={styles.metadataForm__label}>
          Description / Original Prompt
        </label>
        <textarea
          id="quiz-prompt"
          className={styles.metadataForm__textarea}
          value={originalPrompt}
          onChange={(e) => onPromptChange(e.target.value)}
          placeholder="Add a description or the original AI prompt used to generate this quiz"
          rows={3}
          maxLength={500}
        />
      </div>

      <div className={styles.metadataForm__field}>
        <label className={styles.metadataForm__checkboxLabel}>
          <div className={styles.metadataForm__checkboxHeader}>
            <input
              type="checkbox"
              className={styles.metadataForm__checkbox}
              checked={isDailyKnowledge}
              onChange={(e) => onDailyKnowledgeChange(e.target.checked)}
            />
            <span className={styles.metadataForm__checkboxText}>
              Add to Daily Knowledge
            </span>
          </div>
          <span className={styles.metadataForm__hint}>
            Questions from this quiz will appear in your daily practice rotation
          </span>
        </label>
      </div>
    </motion.div>
  );
}
